<template>
<div class="chapter">
<div class="inner_page">
<h1>Small Bites</h1>
<div class="toc"><p><b>Table of Contents</b></p><dl>
<dt><span class="chapter" style="color:#7b3800;"><a href="#/ch01">Introduction
                        </a></span></dt>
<dt><span class="chapter" style="color:#005a6b"><span href="#/ch02" title="Link target outside of Sample">Basic Bites
                        </span></span></dt>
<dd><dl>
<dt><span class="bridgehead"><span href="#/ch02#crisps" title="Link target outside of Sample">Garlic Pita Crisps
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch02#rolls" title="Link target outside of Sample">Baby Sesame Slider
                                    Rolls </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch02#pastry" title="Link target outside of Sample">Crispy Pastry Cups
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch02#crostini" title="Link target outside of Sample">Golden Crostini
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch02#toastcup" title="Link target outside of Sample">Mini Toast Cups
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch02#puffs" title="Link target outside of Sample">Tiny Choux Puffs
                                </span></span></dt>
</dl></dd>
<dt><span class="chapter" style="color:#63003a"><span href="#/ch03" title="Link target outside of Sample">Finger Foods
                        </span></span></dt>
<dd><dl>
<dt><span class="bridgehead"><span href="#/ch03#d0e284" title="Link target outside of Sample">Turkey and Cranberry
                                    Pinwheels </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e311" title="Link target outside of Sample">Artichoke and
                                    Sausage Pizzas </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e343" title="Link target outside of Sample">Smoked Salmon
                                    Cucumber Rounds with Lemon Dill Cream </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e375" title="Link target outside of Sample">Tiny Corn Cakes with
                                    Avocado Pico de Gallo </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#BLT" title="Link target outside of Sample">Mini BLT Cups
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#drumsticks" title="Link target outside of Sample">Honey-Ginger
                                    Mini Drumsticks </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e482" title="Link target outside of Sample">Baby Mexican
                                    Tostadas </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e517" title="Link target outside of Sample">Crispy Lasagna Cups
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e555" title="Link target outside of Sample">Beef Oscar Tartlets
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#wraps" title="Link target outside of Sample">Mini Asian Lettuce
                                    Wraps </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e645" title="Link target outside of Sample">Heavenly Salmon
                                    Mousse Bites </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e675" title="Link target outside of Sample">Coconut Shrimp with
                                    Apricot Sauce </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#riblets" title="Link target outside of Sample">Dry-Rubbed Riblets
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e768" title="Link target outside of Sample">Artichoke Cheese
                                    Wontons </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e798" title="Link target outside of Sample">Mini Crab Cakes with
                                    Mango Chile Salsa </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e860" title="Link target outside of Sample">Fried Artichoke
                                    Hearts </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e893" title="Link target outside of Sample">Crispy Ham and
                                    Gruyère Palmiers </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#potatoes" title="Link target outside of Sample">Tiny Twice-Baked
                                    Potatoes </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#d0e956" title="Link target outside of Sample">Egg Salad–Stuffed
                                    Cherry Tomatoes </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#parmesan" title="Link target outside of Sample">Parmesan-Spinach
                                    Crispies </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch03#nacho" title="Link target outside of Sample">Crab and Avocado
                                    Nachos </span></span></dt>
</dl></dd>
<dt><span class="chapter" style="color:#63003a"><span href="#/ch04" title="Link target outside of Sample">Skewers and
                            Picks </span></span></dt>
<dd><dl>
<dt><span class="bridgehead"><span href="#/ch04#d0e1076" title="Link target outside of Sample">Toasted Ravioli
                                    Pops </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1105" title="Link target outside of Sample">Baby Eggplant
                                    Parmigiana </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1147" title="Link target outside of Sample">Parma Melon Balls
                                    with Citrus-Mint Dressing </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1176" title="Link target outside of Sample">Sesame-Ginger
                                    Teriyaki Meatballs </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1230" title="Link target outside of Sample">Cubano Skewers with
                                    Honey Mustard Sauce </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1231" title="Link target outside of Sample">Mini Corn Dogs with
                                    Special Sauce</span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1315" title="Link target outside of Sample">Bacon-Wrapped
                                    Chévre-Stuffed Apricots </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1341" title="Link target outside of Sample">Prosciutto-Wrapped
                                    Pears with Watercress and Brie </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1367" title="Link target outside of Sample">Roast Beef,
                                    Gorgonzola, and Balsamic-Roasted Grape Skewers </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1396" title="Link target outside of Sample">Cheesy Sausage
                                    Nibbles </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#antipasto" title="Link target outside of Sample">Antipasto Skewers
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1453" title="Link target outside of Sample">Deconstructed Bacon
                                    Jalapeño Poppers </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1479" title="Link target outside of Sample">Mini Cheese Balls
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1521" title="Link target outside of Sample">Honey
                                    Sriracha—Glazed Bacon-Wrapped Scallops </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#greek" title="Link target outside of Sample">Greek Salad on a
                                    Stick </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1581" title="Link target outside of Sample">Salmon Satay with
                                    Thai Peanut Dipping Sauce </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1629" title="Link target outside of Sample">Candied Bacon and
                                    Pineapple Spears </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch04#d0e1658" title="Link target outside of Sample">Macadamia-Crusted
                                    Chicken Bites with Honey Mustard Dipping Sauce </span></span></dt>
</dl></dd>
<dt><span class="chapter" style="color:#536024"><span href="#/ch05" title="Link target outside of Sample">Sliders and Mini
                            Sandwiches </span></span></dt>
<dd><dl>
<dt><span class="bridgehead"><span href="#/ch05#tarragon" title="Link target outside of Sample">Tarragon Chicken
                                    Salad Puffs </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#lobster" title="Link target outside of Sample">Baby Lobster Rolls
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e1793" title="Link target outside of Sample">French Dip Sliders
                                    with Au Jus </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e1843" title="Link target outside of Sample">Pita Bites
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e1874" title="Link target outside of Sample">Beef, Asiago, and
                                    Caramelized Onion Sliders </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#kobekeefkliders" title="Link target outside of Sample">Kobe Beef
                                    Sliders with Secret Sauce </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e1965" title="Link target outside of Sample">Open-Faced Reubens
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2014" title="Link target outside of Sample">Mini Chicken and
                                    Cheese Quesadillas </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2054" title="Link target outside of Sample">Avocado Toasts with
                                    Balsamic Glaze and Cherry Tomatoes </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2093" title="Link target outside of Sample">Asparagus Rolls
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2126" title="Link target outside of Sample">Mini Tuna Melts
                                </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2162" title="Link target outside of Sample">Mini Muffuletta
                                    Sandwiches </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#grilledcheese" title="Link target outside of Sample">Mini Grilled
                                    Cheese Sandwiches with Roasted Tomato Dipping Sauce
                            </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2234" title="Link target outside of Sample">Creamy Mushroom and
                                    Caramelized Onion Crostini </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2290" title="Link target outside of Sample">Shrimp Remoulade
                                    Pita Crisps </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#meatball" title="Link target outside of Sample">Italian Meatball
                                    Sliders </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2367" title="Link target outside of Sample">Mini Pulled Pork
                                    Barbeque Stacks </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#fig" title="Link target outside of Sample">Prosciutto, Pear, Fig,
                                    and Brie Toasts </span></span></dt>
<dt><span class="bridgehead"><span href="#/ch05#d0e2435" title="Link target outside of Sample">About the Author
                                </span></span></dt>
</dl></dd>
<dt><span class="chapter"><span href="#/ch06" title="Link target outside of Sample">Metric Conversion
                    Chart</span></span></dt>
</dl></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01toc.vue?70eda498